export default __webpack_public_path__ + "img/priority/medium.svg";